'use client'

import { SectionHeader } from '@/components/section-header'
import dynamic from 'next/dynamic'

const VideoPlayer = dynamic(() => import('../../app/VideoPlayer'), { ssr: false })

export const AboutGift = () => {
  return (
    <section className="w-full relative py-12 px-4 md:px-[120px]" style={{ backgroundColor: '#009CD2' }}>
      {/* 背景のギフトボックスパターン */}
      <div
        className="absolute inset-0 bg-repeat"
        style={{
          backgroundImage: 'url(/images/about-gift-background.svg)',
          backgroundSize: 'auto',
          opacity: 1,
        }}
      />

      {/* コンテンツ */}
      <div className="max-w-[1440px] mx-auto relative z-10">
        {/* 白い背景のコンテナ */}
        <div className="bg-white rounded-2xl px-8 py-10 md:px-20 md:py-12">
          {/* タイトルと下線 */}
          <div className="mb-6">
            <SectionHeader title="どんなギフト?" />
          </div>

          {/* 説明文 */}
          <div className="text-left lg:text-center mb-8">
            <p
              className="text-xs lg:text-base lg:font-[Hiragino_Kaku_Gothic_Pro,Meiryo,Yu_Gothic,sans-serif]"
              style={{
                fontWeight: 500,
                lineHeight: '1.75',
                letterSpacing: '0.04em',
                color: '#363636',
                marginBottom: '0.25rem',
              }}
            >
              WEB上で簡単に「オリジナルカタログギフト」を作ることができる法人向けサービスです。
            </p>
            <p
              className="text-xs lg:text-base lg:font-[Hiragino_Kaku_Gothic_Pro,Meiryo,Yu_Gothic,sans-serif]"
              style={{
                fontWeight: 500,
                lineHeight: '1.75',
                letterSpacing: '0.04em',
                color: '#363636',
                marginBottom: '0.25rem',
              }}
            >
              贈る相手に「選ぶ楽しみ」を届けるオリジナルeカタログギフト。
            </p>
            <p
              className="text-xs lg:text-base lg:font-[Hiragino_Kaku_Gothic_Pro,Meiryo,Yu_Gothic,sans-serif]"
              style={{
                fontWeight: 500,
                lineHeight: '1.75',
                letterSpacing: '0.04em',
                color: '#363636',
              }}
            >
              送料込み1500円から1点でも購入可能。最短5分で届けることができるビジネスギフトにも最適です。
            </p>
          </div>

          {/* 動画エリア */}
          <div className="w-full max-w-2xl mx-auto">
            <div className="relative" style={{ paddingBottom: '56.25%' }}>
              <div className="absolute inset-0 bg-gray-100 rounded-lg overflow-hidden">
                <VideoPlayer src="https://asset.dev.catalog.giftmall.dev/introduction-movie/video.m3u8" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}
